import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { AlertTriangle, X, Trash2 } from 'lucide-react';
import { DAY_NAMES_SHORT } from './utils';

/**
 * Read-only side panel listing every (employee, date) where ≥2 active
 * assignments exist. Each entry shows the conflicting routes and a quick
 * "Sil" action so the operator can resolve double-bookings without leaving
 * the panel. After delete the parent's `onChange` should refresh the board.
 */
export function ConflictsDialog({ open, conflicts, onClose, onRemoveAssignment, onJumpToCell }) {
  if (!open) return null;
  const trDay = (date) => {
    try { return DAY_NAMES_SHORT[(new Date(date).getDay() + 6) % 7]; } catch { return ''; }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <Card className="max-w-2xl w-full p-0 overflow-hidden flex flex-col max-h-[85vh]" onClick={(e) => e.stopPropagation()} data-testid="planning-conflicts-dialog">
        <div className="px-5 py-3 border-b border-slate-200 dark:border-slate-700 flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-red-500" />
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold">Çakışma Listesi</h3>
            <p className="text-[11px] text-slate-500">
              Bu hafta için aynı çalışana aynı gün birden fazla atama yapılan kayıtlar.
            </p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-red-500" data-testid="planning-conflicts-close">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-3 py-3 space-y-2">
          {conflicts.length === 0 ? (
            <p className="text-xs text-emerald-600 text-center py-6">Çakışma yok 🎉</p>
          ) : (
            conflicts.map((c) => (
              <div key={c.key} className="border border-red-200 rounded-md bg-red-50/40 dark:bg-red-900/10 p-2.5" data-testid={`planning-conflict-row-${c.key}`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold text-red-700">
                    {c.employee_name}
                  </span>
                  {c.firm_name && (
                    <span className="text-[9px] px-1 py-0 rounded bg-indigo-100 text-indigo-700 font-bold uppercase">
                      {c.firm_name}
                    </span>
                  )}
                  <span className="text-[10px] text-slate-500 ml-auto">
                    {trDay(c.date)} · {c.date} · {c.count}× atama
                  </span>
                </div>
                <ul className="space-y-1">
                  {c.assignments.map((a) => (
                    <li key={a.id} className="flex items-center gap-2 px-2 py-1.5 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                      <button
                        onClick={() => onJumpToCell?.(a)}
                        className="text-xs font-semibold hover:text-emerald-600"
                        title="Hücreye git"
                        data-testid={`planning-conflict-jump-${a.id}`}
                      >
                        {a.route_code}
                      </button>
                      <span className="text-[10px] text-slate-500 truncate flex-1">
                        {a.company_name}{a.shift_name ? ` · ${a.shift_name}` : ''}
                      </span>
                      <button
                        onClick={() => onRemoveAssignment?.(a)}
                        className="text-slate-400 hover:text-red-500 p-1"
                        title="Bu atamayı sil"
                        data-testid={`planning-conflict-del-${a.id}`}
                      >
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}
        </div>

        <div className="px-5 py-2 border-t border-slate-100 dark:border-slate-700 flex justify-end">
          <Button variant="ghost" size="sm" onClick={onClose}>Kapat</Button>
        </div>
      </Card>
    </div>
  );
}
